import type { ComponentType, SVGProps } from 'react';
import {
  BellAlertIcon,
  BugAntIcon,
  BuildingStorefrontIcon,
  ChartPieIcon,
  ClipboardDocumentListIcon,
  LightBulbIcon,
  ShieldCheckIcon,
  Squares2X2Icon,
  UserGroupIcon,
  ChatBubbleLeftRightIcon,
  WrenchScrewdriverIcon,
  WrenchIcon,
} from '@heroicons/react/24/outline';

export type AdminNavKey =
  | 'dashboard'
  | 'requests'
  | 'serviceProviders'
  | 'accounts'
  | 'community'
  | 'notifications'
  | 'verifications'
  | 'suggestions'
  | 'productFeedback'
  | 'equipmentTypes'
  | 'specializations'
  | 'tools';

export interface AdminNavItem {
  key: AdminNavKey;
  label: string;
  mobileLabel: string;
  to: string;
  end?: boolean;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const PRIMARY_ADMIN_MOBILE_KEYS: AdminNavKey[] = [
  'dashboard',
  'requests',
  'serviceProviders',
  'accounts',
];

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  {
    key: 'dashboard',
    label: 'Centrum',
    mobileLabel: 'Centrum',
    to: '/admin',
    end: true,
    icon: ChartPieIcon,
  },
  {
    key: 'requests',
    label: 'Zgłoszenia',
    mobileLabel: 'Zgłosz.',
    to: '/admin/requests',
    icon: ClipboardDocumentListIcon,
  },
  {
    key: 'serviceProviders',
    label: 'Serwisy',
    mobileLabel: 'Serwisy',
    to: '/admin/service-providers',
    icon: BuildingStorefrontIcon,
  },
  {
    key: 'accounts',
    label: 'Konta',
    mobileLabel: 'Konta',
    to: '/admin/accounts',
    icon: UserGroupIcon,
  },
  {
    key: 'community',
    label: 'Społeczność',
    mobileLabel: 'Forum',
    to: '/admin/community',
    icon: ChatBubbleLeftRightIcon,
  },
  {
    key: 'verifications',
    label: 'Weryfikacje',
    mobileLabel: 'Weryf.',
    to: '/admin/verifications',
    icon: ShieldCheckIcon,
  },
  {
    key: 'productFeedback',
    label: 'Feedback i diagnostyka',
    mobileLabel: 'Feedback',
    to: '/admin/product-feedback',
    icon: BugAntIcon,
  },
  {
    key: 'suggestions',
    label: 'Sugestie',
    mobileLabel: 'Sugestie',
    to: '/admin/suggestions',
    icon: LightBulbIcon,
  },
  {
    key: 'specializations',
    label: 'Specjalizacje',
    mobileLabel: 'Specj.',
    to: '/admin/specializations',
    icon: WrenchScrewdriverIcon,
  },
  {
    key: 'equipmentTypes',
    label: 'Typy sprzętu',
    mobileLabel: 'Sprzęt',
    to: '/admin/equipment-types',
    icon: Squares2X2Icon,
  },
  {
    key: 'notifications',
    label: 'Powiadomienia',
    mobileLabel: 'Powiad.',
    to: '/admin/notifications',
    icon: BellAlertIcon,
  },
  {
    key: 'tools',
    label: 'Narzędzia',
    mobileLabel: 'Narz.',
    to: '/admin/tools',
    icon: WrenchIcon,
  },
];

export const getAdminActiveItem = (pathname: string): AdminNavItem =>
  ADMIN_NAV_ITEMS.find((item) => {
    if (item.end) {
      return pathname === item.to;
    }
    return pathname === item.to || pathname.startsWith(`${item.to}/`);
  }) || ADMIN_NAV_ITEMS[0];
